import React from "react";
import { Link } from "react-router-dom";
import { ShieldAlert, ArrowLeft } from "lucide-react";
import { useApp } from "../context";
import { isFeatureGated, consentGateCopy } from "../utils/consentGate";

/**
 * Route wrapper. If the signed-in child's parent-consent has expired,
 * children can't open the gated feature until a grown-up clicks the
 * confirm link in their email.
 *
 * Usage:
 *   <ConsentGate feature="ai_tutor"><TutorPage /></ConsentGate>
 */
const ConsentGate = ({ feature, children }) => {
  const { user } = useApp();

  if (!isFeatureGated(user, feature)) return children;

  const label = {
    ai_tutor: "AI Tutor chat",
    family_games: "Family Games",
    marketplace: "the Marketplace",
    adventures: "Adventures",
  }[feature] || "this feature";

  return (
    <div className="min-h-screen pt-24 px-4 flex items-start justify-center" data-testid={`consent-gate-${feature}`}>
      <div className="max-w-md w-full rounded-2xl p-6 bg-gradient-to-br from-amber-500/[0.12] to-orange-500/[0.08] border-2 border-amber-400/30 text-center">
        <div className="w-14 h-14 mx-auto rounded-full bg-amber-500/25 border border-amber-400/40 flex items-center justify-center mb-4">
          <ShieldAlert size={26} className="text-amber-300" />
        </div>
        <h2 className="text-xl font-fredoka font-bold text-white mb-2 drop-shadow-[0_1px_3px_rgba(0,0,0,0.5)]">
          {label} is paused
        </h2>
        <p className="text-white/80 text-sm font-medium leading-relaxed mb-5">
          {consentGateCopy()} While you wait you can still play in the Arcade, Learn, and Art Studio.
        </p>
        <Link
          to="/my-world"
          className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl bg-white/10 hover:bg-white/15 border border-white/20 text-white font-bold text-sm transition-all"
          data-testid={`consent-gate-back-${feature}`}>
          <ArrowLeft size={14} /> Back to My World
        </Link>
      </div>
    </div>
  );
};

export default ConsentGate;
